var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Container, Grid, Typography } from '@mui/material';
import SelectField from '../atoms/SelectField';
import { useOrderListItem } from '../../hooks/useListItem';
import { usePaymentTimingExplanation } from './utils';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 30px;\n\n  &.hide {\n    display: none;\n  }\n"], ["\n  margin-top: 30px;\n\n  &.hide {\n    display: none;\n  }\n"])));
var ExplanationText = styled(Typography).attrs({ variant: 'caption' })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  white-space: pre-line;\n  word-break: break-word;\n"], ["\n  white-space: pre-line;\n  word-break: break-word;\n"])));
var PreOrderForm = function (_a) {
    var offerList = _a.offerList, isValidOrder = _a.isValidOrder, onPaymentTimingChange = _a.onPaymentTimingChange, itemType = _a.itemType;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var paymentTimingItemsWithHandlingRates = useOrderListItem(offerList).paymentTimingItemsWithHandlingRates;
    var _c = React.useState('one_time_upfront'), paymentTiming = _c[0], setPaymentTiming = _c[1];
    var toDateFormat = React.useCallback(function (date) {
        return new Date(date).toLocaleString(i18n.language);
    }, [i18n.language]);
    var handleChangePaymentTiming = React.useCallback(function (e) {
        setPaymentTiming(e.target.value);
        onPaymentTimingChange(e.target.value);
    }, [onPaymentTimingChange]);
    var availablePaymentTimingItems = React.useMemo(function () {
        var paymentTimingItems = paymentTimingItemsWithHandlingRates(itemType, offerList.paymentTimingHandlingRates);
        return paymentTimingItems.filter(function (item) {
            return offerList.availablePaymentTimings.includes(item.value);
        });
    }, [itemType, offerList, paymentTimingItemsWithHandlingRates]);
    var paymentTimingExplanation = usePaymentTimingExplanation(paymentTiming, offerList);
    return (React.createElement(Wrapper, { className: isValidOrder ? '' : 'hide' },
        React.createElement(Container, { maxWidth: "md" },
            React.createElement(Grid, { container: true, spacing: 4 },
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(Typography, { variant: "h5" }, t('pages.roasterOrder.preOrderExplanation', {
                        startedAt: toDateFormat(offerList.orderStartedAt),
                        endedAt: toDateFormat(offerList.expiredAt),
                    }))),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(SelectField, { fullWidth: true, name: "payment_timing", label: t('params.order.paymentTiming'), items: availablePaymentTimingItems, value: paymentTiming, onChange: handleChangePaymentTiming, InputProps: {
                            sx: {
                                '&.MuiInputBase-root > .MuiSelect-select': {
                                    whiteSpace: 'pre-wrap',
                                },
                            },
                        }, SelectProps: {
                            MenuProps: {
                                MenuListProps: {
                                    sx: {
                                        '.MuiMenuItem-root': {
                                            whiteSpace: 'pre-wrap',
                                        },
                                    },
                                },
                            },
                        }, required: true }),
                    React.createElement(ExplanationText, null, paymentTimingExplanation))))));
};
export default PreOrderForm;
var templateObject_1, templateObject_2;
